// extracted by mini-css-extract-plugin
export var body = "ExcursionAccessibilityLevel-module--body--f7ec6";
export var container = "ExcursionAccessibilityLevel-module--container--b5fca";
export var description = "ExcursionAccessibilityLevel-module--description--06045";
export var icon = "ExcursionAccessibilityLevel-module--icon--ec093";
export var sizeBig = "ExcursionAccessibilityLevel-module--size-big--43cdc";
export var title = "ExcursionAccessibilityLevel-module--title--8dc16";
export var withDescription = "ExcursionAccessibilityLevel-module--with-description--d2b2e";